import api from "./apiBase";

const MODULE = "orders";

function createOrder(data, shouldUseFormData = false) {
  if (shouldUseFormData) {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value == null) {
        return;
      }

      if (key === "shippingDocument") {
        if (value instanceof File || value instanceof Blob) {
          formData.append(
            "shippingDocument",
            value,
            value.name || "document.xml",
          );
        }

        return;
      }

      if (Array.isArray(value) || typeof value === "object") {
        formData.append(key, JSON.stringify(value));
        return;
      }

      formData.append(key, String(value));
    });

    return api.post(`${MODULE}/create`, formData);
  }

  return api.post(`${MODULE}/create`, data);
}

function getBuyerOrders(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`${MODULE}/buyer?${query}`);
}

function getOrderDetails(id, type) {
  return api.get(`${MODULE}/${type}/${id}/details`);
}

function getOrderItemPlates(orderItemId) {
  return api.get(`/order-item-plates/${orderItemId}`);
}

function getMakerOrders(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`${MODULE}/maker?${query}`);
}

function getMakerOrdersAccepted(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`${MODULE}/maker/accepted?${query}`);
}

function getMakerOrdersRejected(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`${MODULE}/maker/rejected?${query}`);
}

function getMakerOrdersFinished(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`${MODULE}/maker/finished?${query}`);
}

function acceptMakerOrder(orderId) {
  return api.post(`${MODULE}/maker/${orderId}/accept`);
}

function rejectMakerOrder(orderId) {
  return api.post(`${MODULE}/maker/${orderId}/reject`);
}

function changeStatusMakerOrder(orderId, newStatus) {
  return api.post(`${MODULE}/maker/${orderId}/status`, { newStatus });
}

function getShipmentTag(id) {
  return api.get(`${MODULE}/shipping-tag/${id}`);
}

function trackShipping(id) {
  return api.get(`${MODULE}/tracking-code/${id}`);
}

function getTicketSent(id) {
  return api.get(`${MODULE}/shipping/${id}`);
}

function getPaymentLink(id) {
  return api.get(`${MODULE}/payment-link/${id}`);
}

function markOrderAsReceived(orderId) {
  return api.post(`${MODULE}/buyer/${orderId}/receive`);
}

async function getTempLogoPresignedUrl(file) {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/order-item-customization/temp-logo-presigned", formData);
}

function reportOrderItem(data) {
  return api.post("/maker-reports", data);
}

export {
  markOrderAsReceived,
  createOrder,
  getBuyerOrders,
  getMakerOrders,
  getMakerOrdersAccepted,
  getMakerOrdersRejected,
  getMakerOrdersFinished,
  acceptMakerOrder,
  rejectMakerOrder,
  changeStatusMakerOrder,
  getShipmentTag,
  trackShipping,
  getTicketSent,
  getPaymentLink,
  getTempLogoPresignedUrl,
  reportOrderItem,
  getOrderDetails,
  getOrderItemPlates,
};
